import {createArticleBlockElement} from "@main/components/article";
import {createDomElement} from "@main/helpers/dom";
import {LG_WIDTH} from "@main/helpers/const";

export class Table {
    el;
    leftEdge;
    rightEdge;
    intersectionObserver;
    leftBlur;
    rightBlur;

    constructor(table, isArticle = true) {
        this.table = table;

        this.buildArticleTableDom(isArticle);

        this.provideObservers();

        this.container.addEventListener("scroll", () => {
            this.rightBlur.style.right = `${this.table.getBoundingClientRect().x}`;
        })

        if (window.innerWidth >= LG_WIDTH) {
            this.addMouseWell(this.container, (e) => this.scrollHorizontally(e));
        }
    }

    buildArticleTableDom = (isArticle) => {
        this.container = createDomElement({className: "article-table"});

        if (isArticle) {
            this.articleBlock = createArticleBlockElement();
            this.table.parentNode.insertBefore(this.articleBlock, this.table);
            this.articleBlock.appendChild(this.container);
        } else {
            this.table.parentNode.insertBefore(this.container, this.table);
        }

        this.scrollContainer = createDomElement();

        // элементы на краях таблицы
        this.leftEdge = createDomElement({className: "article-table__left-edge"});
        this.rightEdge = createDomElement({className: "article-table__right-edge"});

        // элементы с градиентом
        this.leftBlur = createDomElement({className: "article-table__left-blur"});
        this.rightBlur = createDomElement({className: "article-table__right-blur"});

        this.container.appendChild(this.leftBlur);
        this.container.appendChild(this.scrollContainer);
        this.scrollContainer.appendChild(this.leftEdge);
        this.scrollContainer.appendChild(this.table);
        this.scrollContainer.appendChild(this.rightEdge);
        this.container.appendChild(this.rightBlur);

        // позиционирование правого крайнего элемента в зависимости от ширины таблицы
        this.rightEdge.style.left = `${this.table.offsetWidth - this.rightEdge.offsetWidth}px`;
    };

    provideObservers = () => {
        this.intersectionObserver = new IntersectionObserver(this.onIntersection, {
            root: this.el,
            threshold: 1.0,
        });

        this.intersectionObserver.observe(this.leftEdge);
        this.intersectionObserver.observe(this.rightEdge);
    };

    onIntersection = (entries) => {
        const leftIntersection = entries.find((entry) => entry.target === this.leftEdge);
        const rightIntersection = entries.find((entry) => entry.target === this.rightEdge);
        if (leftIntersection) {
            switch (leftIntersection.isIntersecting) {
                case true: {
                    this.leftBlur.classList.remove("shown");
                    break;
                }
                case false: {
                    this.leftBlur.classList.add("shown");
                    break;
                }
            }
        }

        if (rightIntersection) {
            switch (rightIntersection.isIntersecting) {
                case true: {
                    this.rightBlur.classList.remove("shown");
                    break;
                }
                case false: {
                    this.rightBlur.classList.add("shown");
                    break;
                }
            }
        } else {
            this.rightBlur.classList.add("shown");
        }
    };

    /**
     * Горизонтальный скролл таблицы.
     * 
     * @param {Event} e Событие, происходящее при прокрутке колесика мышки.
     * @returns {void}
     */
    scrollHorizontally(e) { 
        e = window.event || e;
        const delta = Math.max(-25, Math.min(25, (e.wheelDelta || -e.detail))); 
        this.container.scrollLeft -= (delta * 10); 
        e.preventDefault();
    }
    
    /**
     * Добавление события прокрутки колесиком мыши.
     * 
     * @param {HTMLElement} elem Элемент, который будет прокручиваться.
     * @param {FunctionStringCallback} callback Колбэк.
     * @returns {void}
     */
    addMouseWell(elem, callback) { 
        if (elem.addEventListener) {
            if ("onwheel" in document) {
                elem.addEventListener("wheel", callback);
            } else if ("onmousewheel" in document) {
                elem.addEventListener("mousewheel", callback);
            } else {
                elem.addEventListener("MozMousePixelScroll", callback);
            }
        } else {
            elem.attachEvent("onmousewheel", callback);
        }
    }
}

document.querySelectorAll(".js-table-scroll").forEach((el) => new Table(el, false));
